import type {
    WebMcpListResponse,
    WebMcpDetailItem,
    WebMcpEnableData,
    WebMcpListParams,
    WebMcpDetailParams,
} from '../types';

export const McpApiService = Symbol('McpApiService');

export interface McpApiService {
    getList(params?: WebMcpListParams): Promise<WebMcpListResponse>;
    getDetail(name: string, params?: WebMcpDetailParams): Promise<WebMcpDetailItem>;
    enable(name: string): Promise<WebMcpEnableData>;
    disable(name: string): Promise<WebMcpEnableData>;
}
